import intl from 'react-intl-universal';

import { ReducerState } from '@/redux/reducers/reservation/reserveEditor';
import DateJS from '@/utils/date';
import { findItemByKey } from '@/redux/actions/reservation/helper';
import { SourceChannelType } from '@/config/constant';
import { PRICE_REG } from '@/config/reg';
import {
  ValidateSchema,
  channelOrderNoValidater,
  createValidator,
} from '@/pages/reservation/utils/validator';

const rentTimeInfo: (value: ReducerState['rentTimeInfo'], data: ReducerState) => void = (
  value,
  data,
) => {
  const { expectedArrivalTime, rentTime } = value;
  const { ETATimeRange } = data.commonInfo;

  const [minETATime, maxETATime] = ETATimeRange || [];

  let err;
  switch (true) {
    // 预抵时间为空
    case !expectedArrivalTime:
      err = 'reservation_error_eta_null';
      break;
    // 入住时长为空
    case !rentTime:
      err = 'reservation_error_duration_null';
      break;
    // 修改的时间不得跨越营业日，例如原先是2023年8月4日03:00:00预抵，则修改范围是 2023年8月3日06:00:00~ 2023年8月4日05:59:59
    case minETATime && DateJS(expectedArrivalTime).isBefore(minETATime, 'second'):
    case maxETATime && DateJS(expectedArrivalTime).isSameOrAfter(maxETATime, 'second'):
      err = 'drawer_order_editor_error_cross_business_date';
      break;
    default:
      return '';
  }

  if (err) {
    throw new Error(intl.get(err));
  }
  return null;
};

const channelInfo: (value: ReducerState['channelInfo'], data: ReducerState) => void = (
  value,
  data,
) => {
  const { channelId, channelOrderNo } = value;
  const { channelList } = data;
  const targetChannel = findItemByKey(channelList, 'id', channelId);
  // OTA 渠道 且非直连
  const shouldCheckOrder =
    targetChannel && targetChannel.type === SourceChannelType.OTA && !targetChannel.directFlag;

  let err;
  switch (true) {
    case !channelId:
      err = 'reservation_error_channel_null';
      break;
    case shouldCheckOrder && !channelOrderNo:
      err = 'reservation_error_ota_no_null';
      break;
    case shouldCheckOrder && !channelOrderNoValidater(targetChannel.otaBillType, channelOrderNo):
      err = 'reservation_error_channelNo_format';
      break;
    default:
      return '';
  }

  if (err) {
    throw new Error(intl.get(err));
  }
  return null;
};

const rentRoomInfos: (value: ReducerState['rentRoomInfos']) => void = (value) => {
  const rentList = value || [];

  if (rentList.length) {
    rentList.forEach((item) => {
      const { roomPriceList } = item;
      (roomPriceList || []).forEach((rentDay) => {
        if (!rentDay.inputPrice) {
          throw new Error(intl.get('reservation_error_room_price_null'));
        }
        if (!PRICE_REG.test(rentDay.inputPrice)) {
          throw new Error(intl.get('reservation_error_room_price_invalid'));
        }
      });
    });
  } else {
    throw new Error(intl.get('reservation_error_room_count_null'));
  }

  return null;
};

const mainSchema: ValidateSchema<ReducerState> = {
  rentTimeInfo,
  channelInfo,
  rentRoomInfos,
};

export default createValidator<ReducerState>(mainSchema);
